import React from 'react';
import { MapPin, Navigation, X, Car, Calendar, Building } from 'lucide-react';
import { CarShareBayOperatorLocation } from '../types';

interface CarShareBayOperatorPopupProps {
  location: CarShareBayOperatorLocation;
  onClose: () => void;
}

const CarShareBayOperatorPopup: React.FC<CarShareBayOperatorPopupProps> = ({ location, onClose }) => {
  const handleBackdropClick = (e: React.MouseEvent) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div className="car-share-bay-operator-modal-backdrop" onClick={handleBackdropClick}>
      <div className="car-share-bay-operator-modal">
        {/* Modal Header */}
        <div className="modal-header">
          <h3 className="modal-title">
            <Car size={20} />
            Car Share Bay
          </h3>
          <button onClick={onClose} className="modal-close-button">
            <X size={20} />
          </button>
        </div>

        {/* Modal Content */}
        <div className="modal-content">
          <div className="location-details">
            <div className="detail-row">
              <span className="detail-label">Bay ID:</span>
              <span className="detail-value">{location.bayId}</span>
            </div>
            <div className="detail-row">
              <span className="detail-label">Operator:</span>
              <span className="detail-value">{location.operator}</span>
            </div>
            <div className="detail-row">
              <span className="detail-label">Street:</span>
              <span className="detail-value">{location.street}</span>
            </div>
            <div className="detail-row">
              <span className="detail-label">Suburb:</span>
              <span className="detail-value">{location.suburb}</span>
            </div>
            <div className="detail-row">
              <span className="detail-label">Coordinates:</span>
              <span className="detail-value">
                {location.latitude.toFixed(6)}, {location.longitude.toFixed(6)}
              </span>
            </div>
          </div>

          {/* Car Share Information */}
          <div className="car-share-details">
            <h4 className="section-title">Car Share Information</h4>
            <div className="detail-row">
              <span className="detail-label">
                <Building size={16} />
                Operator:
              </span>
              <span className="detail-value">{location.operator}</span>
            </div>
            <div className="detail-row">
              <span className="detail-label">
                <Car size={16} />
                Bay Type:
              </span>
              <span className="detail-value">Car Share Bay</span>
            </div>
          </div>

          {/* Action Buttons */}
          <div className="modal-actions">
            <a
              href={`https://www.google.com/maps/dir/?api=1&destination=${location.latitude},${location.longitude}`}
              target="_blank"
              rel="noopener noreferrer"
              className="directions-button"
            >
              <Navigation size={16} />
              Get Directions
            </a>
            <a
              href={`https://www.google.com/maps/@?api=1&map_action=pano&viewpoint=${location.latitude},${location.longitude}`}
              target="_blank"
              rel="noopener noreferrer"
              className="streetview-button"
            >
              <MapPin size={16} />
              Street View
            </a>
          </div>

          {/* Powered by City of Sydney Card */}
          <div className="powered-by-sydney-card">
            <div className="powered-by-content">
              <div className="powered-by-text">Powered by</div>
              <div className="city-of-sydney-logo">
                <img
                  src="/instantAppsConfigPanel_1712885390298_Anchor_White.png"
                  alt="City of Sydney Logo"
                  className="city-logo-image"
                />
                <span className="city-name">City of Sydney</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CarShareBayOperatorPopup;
